import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fb4974f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-body" }
const _hoisted_5 = { class: "modal-card-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mostrar)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["modal", { 'is-active': _ctx.mostrar }])
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _renderSlot(_ctx.$slots, "cabecalho", {}, undefined, true)
          ]),
          _createElementVNode("section", _hoisted_4, [
            _renderSlot(_ctx.$slots, "conteudo", {}, undefined, true)
          ]),
          _createElementVNode("footer", _hoisted_5, [
            _renderSlot(_ctx.$slots, "rodape", {}, undefined, true)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}